export  class BaseEntity {
    id: number;
}